(function(){
  let sidecar = document.createElement('script');
  sidecar.type= 'text/javascript';
  sidecar.async= true;
  sidecar.src= '/sidecar/scripts.js';
  let s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(sidecar, s);
})();
